import { AxiosResponse } from 'axios';
import { MutationOptions, useMutation } from '@tanstack/react-query';
import { validateRuleExpression } from 'Services';
import { RQ_VALIDATE_RULE_EXPRESSION } from 'Utils';

type Options = {
    mutationOptions: Omit<MutationOptions<AxiosResponse<AdvancedRuleExpression>, any, any, any>, 'mutationKey'>;
};

function useValidateRuleExpression({ mutationOptions }: Options) {
    return useMutation([RQ_VALIDATE_RULE_EXPRESSION], validateRuleExpression, {
        ...mutationOptions,
        onSuccess: (data, variables, context) => {
            mutationOptions.onSuccess?.(data, variables, context);
        },
        onError: async (error, variables, context) => mutationOptions.onError?.(error, variables, context)
    });
}

export default useValidateRuleExpression;
